<template>
  <div class="project-list-container">
    <TagsCloud ref="cloudtage" @cloudTages="cloudTages" />
    <div class="project-table">
      <avue-crud
        :option="tableConfig"
        :data="tableData"
        v-model="searchForm"
        :page.sync="page"
        :search.sync="searchForm"
        @search-reset="searchReset"
        @on-load="queryListData"
        @search-change="searchChange"
        @sort-change="sortChange"
        @selection-change="selectionChange"
      >
        <template slot="menuRight">
          <el-tooltip class="item" effect="dark" content="显隐" placement="top">
            <el-button
              icon="el-icon-s-operation"
              size="small"
              circle
              @click="operation"
            ></el-button>
          </el-tooltip>
        </template>

        <template slot="sellerCustNameSearch">
          <CommonSelect
            ref="customDict"
            bindLabel="dictValue"
            bindKey="dictKey"
            bindValue="dictValue"
            dataUrl="/blade-/zd/custom/dict"
            @handleChange="setSellerCustId"
          />
        </template>

        <template slot="searchMenu" slot-scope="{ row }">
          <el-button type="primary" @click="save(row)">保存</el-button>
          <!-- <el-button type="primary"  @click="openFilter">
            <a-icon type="filter" /> 高级筛选
          </el-button> -->
        </template>

        <template slot="menuLeft">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click.stop="handleAdd()"
            v-if="permission.factoringProjectManage_add"
            >新建项目
          </el-button>
          <!-- <el-button
            type="primary"
            size="small"
            icon="el-icon-edit"
            plain
            @click.stop="handleEdit()"
            >编辑
          </el-button> -->
          <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            plain
            @click.stop="handleDelete()"
             v-if="permission.factoringProjectManage_delete"
            >删除
          </el-button>
          <el-button
            size="small"
            icon="el-icon-download"
            @click="exportShow"
          >导出数据
          </el-button>
        </template>

        <template slot="name" slot-scope="{ row }">
          <div class="project-name" @click="goDetail(row)">{{row.name}}</div>
        </template>
      </avue-crud>
    </div>
    
    <Options
      ref="Options"
      :plainOptions="optionColumn"
      :pageDataId="this.$route.path"
      @returnData="returnData"
    />

    <ExportData ref="exportData" @exportDownload="exportDownload" />    
  </div>
</template>
<script>
import TagsCloud from "@/components/TagsCloud/TagsCloud";
import { downLoadTemplate } from "@/router/downLoadTem";
import { projectTableConfig } from './projectConfig'
import Options from "@/components/ShowHidden/showhidden";
import SelectPerson from "@/components/SelectPersonnel/person";
import SelectDepartment from "@/components/SelectDepartment/department";
import CommonSelect from "@/components/commonSelect/commonSelect"
import ExportData from "@/components/exportData/exportData";
import {queryFactoringProjectList, deleteFactoringProject} from "@/api/factoring/factoring"
import { mapGetters } from "vuex";
export default {
  name: 'PeojectList',
  data() {
    return {
      tableConfig: projectTableConfig(this.getMoney),
      selectionList: [],
      tableData: [],
      searchForm: {},
      optionColumn: {},
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10
      }
    }
  },
  computed: {
    ...mapGetters(["userInfo",'permission']),
  },
  components: {
    CommonSelect,
    TagsCloud,
    SelectPerson,
    SelectDepartment,
    ExportData,
    Options
  },
  created() {
    this.optionColumn = this.deepClone(this.tableConfig.column)
    // 只读权限取消选择框显示
    if(this.permission.factoringProjectView_view) this.tableConfig.selection = false
    this.queryListData()
  },
  methods: {
    searchChange(str, done) {
      this.queryListData()
      done()
    },
    setSellerCustId(data) {
      this.searchForm.sellerCustId = data.dictKey
      this.searchForm.sellerCustName = data.dictValue
    },
    operation() {
      this.$refs.Options.showmode();
    },

    returnData(data) {
      // this.tableConfig.column = data
    },

    async queryListData() {
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchForm
      }      
      let res = await queryFactoringProjectList(params)
      if(res.data.code == 200) {
        this.tableData = res.data.data.records
        this.page.total = res.data.data.total
      }else {
        this.$message.error(res.data.msg)
      }      
    },

    handleEdit() {
      if(this.selectionList.length > 1){
        this.$message.error('只能选择一条数据进行编辑')
      }else if(this.selectionList.length == 1){
        this.$router.push({
          path: `/factoring/projectManage/projectDetail/${this.selectionList[0].id}`,
        })
      }else{
        this.$message.error('请选择一条数据进行编辑')
      }
    },    

    goDetail(row) {
      if(!this.permission.factoringProjectManage_view){
        this.$message.error("没有查看权限");
        return 
      }

      this.$router.push({
        path: `/factoring/projectManage/projectDetail/${row.id}`,
      })
    },    

    selectionChange(list) {
      this.selectionList = list
    },
    
    cloudTages(data) {
      this.searchForm = data
    },

    save(row) {
      this.$refs.cloudtage.save(row);
    },

    filterSearch(str, done) {
      this.page.currentPage = 1
      this.queryListData()
      done()
    },

    searchReset() {
      this.searchForm = {}
      this.$refs.customDict.reset()
      this.page.currentPage = 1
      this.queryListData()
    },

    handleAdd() {
      this.$router.push({
        path: "/factoring/projectManage/projectAdd"
      })
    },

    exportShow() {
      this.$refs.exportData.showModel();
    },    

    handleDelete() {
      let self = this
      if(this.selectionList.length > 1){
        this.$message.error('只能选择一条数据进行删除')
      } else if(this.selectionList.length == 1){
        if(this.selectionList[0].managerUser == this.userInfo.user_id){
          this.$confirm('确定删除选择的数据?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            // self.deleteData()
            let res = await deleteFactoringProject({ids: self.selectionList[0].id})
            if(res.data.code == 200){
              self.queryListData()
              self.$message({
                type: 'success',
                message: '删除成功'
              })
            }else{
              self.$message({
                type: 'warning',
                message: res.data.msg
              });
            }
          }).catch(() => {
            self.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        }else {
          this.$message.warning('您没有权限删除此条数据')
        }
      }else{
        this.$message.error('请选择数据进行删除')
      }
    },

    // 删除参数ids 提取this.selectionList中的id用,隔开成字符串
    async deleteData() {
      let ids = this.selectionList.map((item) => {
        return item.id
      })
      // let res = await deleteFactoring({ids: ids.join(',')})
      // if(res.data.code == 200){
      //   this.$message.success('删除成功')
      //   // 刷新列表
      //   this.queryListData()
      // }
    },

    exportDownload(value) {
     let page = this.page;
      let data = {
        export: value.code,
        auditState: 1
      };
      if (value.code == 1) {
        data = {
          ...data,
          firstNum: (page.currentPage - 1) * page.pageSize,
          num: page.pageSize,
          ...this.searchForm,
        };
      } else if (value.code == 2) {
        data = {
          ...data,
          ...this.searchForm,
        };
      }
      downLoadTemplate("/api/bl/blprojectinfo/export", data, 'get').finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },

    openFilter() {
      // 回显界面的筛选选项
      // this.form = { ...this.form, ...this.query };
      this.drawer = true;      
    }    
    
  }
}
</script>
<style lang="scss" scoped>
.project-list-container{
  /deep/.el-table .cell  {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }  
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .project-table {
    background: #ffff;
    padding: 25px;
  }
  .project-name{
    // overflow: hidden;
    white-space: normal;
    // text-overflow: ellipsis;
    color: #409EFF;
  }
  .project-name:hover{
    color: #409EFF;
    cursor: pointer;
  }
}
.none-border {
  border: 0;
  background-color: transparent !important;
}
</style>
<style lang="scss">
.project-list-container {
  .el-table__fixed, .el-table__fixed-right {
    height: calc(100% - 10px) !important;
  }
  .el-table__fixed-footer-wrapper{
    display: none !important;
  }  
}
</style>